import useParentLoaderData from "../../../../../../hooks/useParentLoaderData";
import { currencyFormatter } from "../../../../../global/helpers";

const Details = () => {
  const { _case, _staticBar } = useParentLoaderData();

  return (
    <article className="w-full mb-8">
      {/* Client name */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-2xl font-semibold">{_case?.client?.name}</h3>
        <div className="flex gap-2">
          <p className="w-fit">
            <b>DOB:</b> {_staticBar.dateOfBirth?.value} ({_staticBar.age?.value}
            )
          </p>
          <p className="w-fit">
            <b>Preferred Language:</b>{" "}
            {_staticBar.preferredLanguage?.value || "N/A"}
          </p>
        </div>
      </div>
      {/* Statistics grid and location */}
      <div className="flex items-center justify-between">
        {/* Statistics grid */}
        <div className="flex justify-between w-fit">
          <div className="grid">
            <p className="text-sm">Medical Limits</p>
            <span className="text-4xl">
              {currencyFormatter.format(_staticBar?.medicalLimits?.value)}
            </span>
          </div>
          {/* Divider */}
          <div className="mx-4 border-r-2 border-gray-300"></div>
          <div className="grid">
            <p className="text-sm">Current Balance</p>
            <span className="text-4xl">
              {currencyFormatter.format(_staticBar?.currentBalanceTotal?.value)}
            </span>
          </div>
          {/* Divider */}
          <div className="mx-4 border-r-2 border-gray-300"></div>

          <div className="grid">
            <p className="text-sm">Running Total</p>
            <span className="text-4xl">
              {currencyFormatter.format(_staticBar?.runningTotal?.value)}
            </span>
          </div>
        </div>

        <div className="grid gap-2 w-fit">
          <p className="w-full text-end">
            <b>DOA:</b> {_staticBar.dateOfAccident?.value}
          </p>
          <p className="w-full text-end">
            <b>Location:</b> {_staticBar.incidentCity?.value},{" "}
            {_staticBar.incidentState?.value}
          </p>
        </div>
      </div>
    </article>
  );
};

export default Details;
